import React from "react";
import { FeatherAlertCircle } from "@subframe/core";
import { Badge } from "../../ui";
import { OtherIncomeCategoryDetails } from "../../services/api";

interface CustomerOtherIncomeViewContentProps {
  details: OtherIncomeCategoryDetails | null;
  isLoading: boolean;
}

const formatDate = (value?: string) => {
  if (!value) return "—";
  const date = new Date(value);
  return isNaN(date.getTime()) ? "—" : date.toLocaleDateString();
};

const CustomerOtherIncomeViewContent: React.FC<
  CustomerOtherIncomeViewContentProps
> = ({ details, isLoading }) => {
  const hasDetails = Boolean(details);

  return (
    <div className="flex w-full flex-col gap-4 rounded-md border border-solid border-neutral-border bg-neutral-50 px-6 py-6">
      <div className="flex w-full items-center justify-between">
        <div className="flex flex-wrap items-center gap-3">
          <span className="text-heading-3 font-heading-3 text-default-font">
            Other Income Details
          </span>
          <Badge variant="neutral">Other Income</Badge>
        </div>
      </div>

      {isLoading ? (
        <div className="flex w-full items-center justify-center py-12 text-body text-subtext-color">
          Loading transaction details...
        </div>
      ) : !hasDetails ? (
        <div className="flex w-full flex-col items-center gap-2 rounded border border-dashed border-neutral-border px-4 py-6 text-center text-body text-subtext-color">
          <FeatherAlertCircle className="text-neutral-400" />
          <span>No other income details available for this transaction.</span>
        </div>
      ) : (
        <div className="grid gap-4 md:grid-cols-2">
          <div className="flex flex-col rounded border border-neutral-border bg-white px-4 py-3">
            <span className="text-caption text-subtext-color">From Account</span>
            <span className="text-body-bold text-default-font">
              {details?.from_account_name || "—"}
            </span>
          </div>
          <div className="flex flex-col rounded border border-neutral-border bg-white px-4 py-3">
            <span className="text-caption text-subtext-color">Date</span>
            <span className="text-body-bold text-default-font">
              {formatDate(details?.date)}
            </span>
          </div>
          <div className="flex flex-col rounded border border-neutral-border bg-white px-4 py-3">
            <span className="text-caption text-subtext-color">Received Via</span>
            <span className="text-body-bold text-default-font">
              {details?.payment_mode || "—"}
            </span>
          </div>
          <div className="flex flex-col rounded border border-neutral-border bg-white px-4 py-3">
            <span className="text-caption text-subtext-color">
              Reference Number
            </span>
            <span className="text-body-bold text-default-font">
              {details?.reference_number || "—"}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerOtherIncomeViewContent;

